import { useTranslation } from 'react-i18next';
import { ChevronRightIcon } from '@heroicons/react/20/solid';
import { FaChevronDown } from "react-icons/fa";
import { sectionStyles } from '../styles/globalStyles';

const About = () => {
    const { t } = useTranslation();

    return (
        <section id="about" className={sectionStyles.section}>
            <div className={sectionStyles.container}>
                <div className={sectionStyles.title}>
                    <p className={sectionStyles.breadcrumb}>
                        <ChevronRightIcon className="w-4 h-4 mr-2" />
                        {t('about.title')}
                    </p>
                    <h2 className={sectionStyles.heading}>
                        {t('about.subtitle')}
                    </h2>
                </div>
                <p className="text-lg text-left">
                    {t('about.bio')}
                </p>
                                <p className="text-lg text-left">
                    {t('about.bio2')}
                </p>
                                <p className="text-lg mb-8 text-left">
                    {t('about.bio3')}
                </p>
            <p className="motion-safe:animate-bounce text-md font-light text-3xl lg:mt-12 flex justify-center items-center cursor-pointer" onClick={() => document.querySelector('#skills').scrollIntoView({ behavior: 'smooth' })}>
                          <FaChevronDown />
                        </p>
            </div>
        </section>
    );
};

export default About;